import { useContext } from 'react';
import { RecentlyCreatedContext } from '../contexts/RecentlyCreatedContext';

export const useRecentlyCreated = () => {
  const context = useContext(RecentlyCreatedContext);
  if (!context) {
    throw new Error(
      'useRecentlyCreated must be used within a RecentlyCreatedProvider'
    );
  }
  return context;
};
